var React = require('react');

function ArrLeftTop (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M1.70078 2.69009L1.70078 11.0001L0.300781 11.0001L0.300781 1.00014L0.300781 0.300142L1.00078 0.300142L11.0008 0.300142L11.0008 1.70014L2.69073 1.70014L11.4958 10.5052L10.5058 11.4951L1.70078 2.69009Z","fill":"#303030"}));
}

ArrLeftTop.defaultProps = {"width":"12","height":"12","viewBox":"0 0 12 12","fill":"none"};

module.exports = ArrLeftTop;

ArrLeftTop.default = ArrLeftTop;
